import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PickupService } from '@checkout-v2/feature';
import { MyShopService } from '@my-shop/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Pos } from '@shop/const';
import { ShopListService } from '@shop/feature';
import { ModalService } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SdvorPickupActiveShopSchemeModalComponent } from '../pickup-active-shop-scheme-modal';

@Component({
  selector: 'sd-pickup-active-shop',
  templateUrl: './pickup-active-shop.component.html',
  styleUrls: ['./pickup-active-shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupActiveShopComponent implements OnInit {
  iconType = CUSTOM_ICON_TYPE;

  shop$: Observable<Pos>;
  disable$: Observable<boolean>;
  isMyShop$: Observable<boolean>;

  constructor(
    protected modalService: ModalService,
    private pickupService: PickupService,
    private myShopService: MyShopService,
    private shopListService: ShopListService,
  ) {}

  ngOnInit(): void {
    this.shop$ = combineLatest([
      this.pickupService.activeShop$,
      this.myShopService.activeShop$,
      this.shopListService.shops$,
    ]).pipe(
      map(([pickupShop, myShop, shops]: [Pos, Pos, Pos[]]) => {
        if (pickupShop) {
          return pickupShop;
        }

        if (myShop && shops && !shops.some((shop) => shop.name === myShop.name)) {
          return myShop;
        }

        return undefined;
      }),
    );

    this.disable$ = combineLatest([this.pickupService.activeShop$, this.myShopService.activeShop$]).pipe(
      map(([pickupShop, myShop]) => !pickupShop && !!myShop),
    );

    this.isMyShop$ = combineLatest([this.pickupService.activeShop$, this.myShopService.activeShop$]).pipe(
      map(([pickupShop, myShop]) => !!pickupShop && !!myShop && pickupShop.name === myShop.name),
    );
  }

  openModal(): void {
    const modalRef = this.modalService.open(SdvorPickupActiveShopSchemeModalComponent, {
      centered: true,
      size: 'md',
    });

    this.shop$.pipe(take(1)).subscribe((shop) => (modalRef.componentInstance.scheme = shop.scheme));
  }
}
